module.exports = __webpack_public_path__ + "img/SBA_logo.4b23928f.svg";